<template>
  <div class="container">
    <!--<div class="result_tit">-->
    <!--<img src="../../assets/images/testresulttit.png"/>-->
    <!--</div>-->
    <!--<div class="result_instructions">-->
    <!--<div class="result_title">-->
    <!--<div>“</div>-->
    <!--<div>{{txtStr}}</div>-->
    <!--<div>”</div>-->
    <!--</div>-->
    <!--<div class="result_n1">（{{codeStr}}）</div>-->
    <!--&lt;!&ndash;<div class="result_n2_desc">&ndash;&gt;-->
    <!--&lt;!&ndash;<table width="100%">&ndash;&gt;-->
    <!--&lt;!&ndash;<tr>&ndash;&gt;-->
    <!--&lt;!&ndash;<td>&ndash;&gt;-->
    <!--&lt;!&ndash;<div class="main_t">N</div>&ndash;&gt;-->
    <!--&lt;!&ndash;<div class="main_d">(肤质)</div>&ndash;&gt;-->
    <!--&lt;!&ndash;</td>&ndash;&gt;-->
    <!--&lt;!&ndash;<td>&ndash;&gt;-->
    <!--&lt;!&ndash;<div class="main_t">S2</div>&ndash;&gt;-->
    <!--&lt;!&ndash;<div class="main_d">(敏感)</div>&ndash;&gt;-->
    <!--&lt;!&ndash;</td>&ndash;&gt;-->
    <!--&lt;!&ndash;<td>&ndash;&gt;-->
    <!--&lt;!&ndash;<div class="main_t">SR2</div>&ndash;&gt;-->
    <!--&lt;!&ndash;<div class="main_d">(光敏反应)</div>&ndash;&gt;-->
    <!--&lt;!&ndash;</td>&ndash;&gt;-->
    <!--&lt;!&ndash;<td>&ndash;&gt;-->
    <!--&lt;!&ndash;<div class="main_t">P2</div>&ndash;&gt;-->
    <!--&lt;!&ndash;<div class="main_d">(色素)</div>&ndash;&gt;-->
    <!--&lt;!&ndash;</td>&ndash;&gt;-->
    <!--&lt;!&ndash;<td>&ndash;&gt;-->
    <!--&lt;!&ndash;<div class="main_t">W0</div>&ndash;&gt;-->
    <!--&lt;!&ndash;<div class="main_d">(皱纹)</div>&ndash;&gt;-->
    <!--&lt;!&ndash;</td>&ndash;&gt;-->
    <!--&lt;!&ndash;</tr>&ndash;&gt;-->
    <!--&lt;!&ndash;<tr>&ndash;&gt;-->
    <!--&lt;!&ndash;<td class="main_v">中性</td>&ndash;&gt;-->
    <!--&lt;!&ndash;<td class="main_v">二度</td>&ndash;&gt;-->
    <!--&lt;!&ndash;<td class="main_v">二度</td>&ndash;&gt;-->
    <!--&lt;!&ndash;<td class="main_v">二度</td>&ndash;&gt;-->
    <!--&lt;!&ndash;<td class="main_v">紧致型</td>&ndash;&gt;-->
    <!--&lt;!&ndash;</tr>&ndash;&gt;-->
    <!--&lt;!&ndash;</table>&ndash;&gt;-->
    <!--&lt;!&ndash;</div>&ndash;&gt;-->
    <!--<div class="result_test">-->
    <!--<img src="../../assets/images/testreload.png" @click="handleTest"/>-->
    <!--</div>-->
    <!--<div class="result_skin_peculiarity" v-if="info.skin_desc">-->
    <!--<div class="header">-->
    <!--<div class="tit">-->
    <!--<img src="../../assets/images/testskinpeculiarity.png"/>-->
    <!--</div>-->
    <!--</div>-->
    <!--<div class="con">-->
    <!--{{info.skin_desc}}-->
    <!--</div>-->
    <!--</div>-->
    <!--<div class="result_testnursing" v-if="info.nurs_desc">-->
    <!--<div class="header">-->
    <!--<div class="tit">-->
    <!--<img src="../../assets/images/testnursing.png"/>-->
    <!--</div>-->
    <!--</div>-->
    <!--<div class="con">-->
    <!--{{info.nurs_desc}}-->
    <!--</div>-->
    <!--</div>-->
    <!--</div>-->

    <!--<div class="result_instructions" v-if="info.skin_type && info.skin_type.length>0">-->
    <!--<div class="result_title">-->
    <!--<div>“</div>-->
    <!--<div>{{info.skin_type}}</div>-->
    <!--<div>”</div>-->
    <!--</div>-->
    <!--<div class="result_list_x">-->
    <!--<div class="header">-->
    <!--<div class="tit">-->
    <!--<img src="../../assets/images/testtstit.png"/>-->
    <!--</div>-->
    <!--</div>-->
    <!--<div class="con_d">-->
    <!--建议先由医院专业医师就诊治疗，后期可搭配使用喷雾、可愈、面膜等修复-->
    <!--</div>-->
    <!--</div>-->
    <!--<div class="result_test">-->
    <!--<img src="../../assets/images/testreload.png" @click="handleTest"/>-->
    <!--</div>-->
    <!--<div class="goprolist" @click="handleGoList">-->
    <!--查看更多商品 <span></span>-->
    <!--</div>-->
    <!--</div>-->

    <div class="result_list">
      <div class="header">
        <div class="tit">
          <img :src="actImgPath" />
        </div>
      </div>
      <div class="list">
        <van-checkbox-group v-model="resultlist">
          <div class="itembg" v-for="(item, index) in info.itemlist" :key="item.skuid">
            <div class="item">
              <div class="ck">
                <van-checkbox :name="item.skuid" checked-color="#F20023"></van-checkbox>
              </div>
              <div class="proitem">
                <div class="img" @click="productDetailsFn(item)">
                  <img v-lazy="item.path" />
                </div>
                <div class="con">
                  <div class="tit" @click="productDetailsFn(item)">
                    {{ item.name }}
                  </div>
                  <div class="spec">
                    <div class="spec_con" @click="openSku(item, index)">
                      {{ item.spec }}
                      <van-icon name="arrow-down" />
                    </div>
                  </div>
                  <div class="priceAndnum">
                    <div class="price" @click="productDetailsFn(item)">
                      <span class="fh">¥</span>
                      <span class="positive">{{ item.sales_price | salespricepositive }}</span>
                      <span class="dian">.</span>
                      <span class="decimal">{{ item.sales_price | salespricedecimal }}</span>
                    </div>
                    <div class="num">
                      <van-stepper v-model="item.num" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="act_desc_tag"
              @click="showActDesc(item)"
              v-if="
                parseInt(item.ispresale) == 1 ||
                parseInt(item.isdiscount) == 1 ||
                parseInt(halfprice.halfpricestatus) == 1
              "
            >
              <van-tag color="#FEE9E6" text-color="#F12A0E" v-if="parseInt(item.ispresale) == 1">
                预售
              </van-tag>
              <van-tag color="#FEE9E6" text-color="#F12A0E" v-if="parseInt(item.isdiscount) == 1">
                {{ discountrule.actlabel }}
              </van-tag>
              <van-tag color="#FEE9E6" text-color="#F12A0E" v-if="parseInt(item.isfullgift) == 1">
                {{ fullgiftrule.actlabel }}
              </van-tag>
              <van-tag
                color="#FEE9E6"
                text-color="#F12A0E"
                v-if="parseInt(halfprice.halfpricestatus) == 1"
              >
                {{ halfprice.halfactlabel }}
              </van-tag>
              <van-icon name="arrow" />
            </div>
            <div class="act_desc_time" v-if="parseInt(item.ispresale) == 1">
              <img src="../../assets/images/presell.png" />
              <div class="txt">预售发货时间：{{ item.presaletime }}</div>
            </div>
            <div class="act_desc" v-if="item.rulelist">【秒杀】秒杀活动开始时间还剩 08:12:00</div>
          </div>
        </van-checkbox-group>
      </div>
      <div class="additemMsg" v-if="FlodMsg">
        <div class="msg">
          <img src="../../assets/images/surprised.png" />
          <div class="txt" v-html="FlodMsg"></div>
        </div>
      </div>
      <div class="additemMsg" v-if="fullGiftMsg">
        <div class="msg">
          <img src="../../assets/images/surprised.png" />
          <div class="txt" v-html="fullGiftMsg"></div>
        </div>
      </div>
      <div class="settlement">
        <div class="pro_tools">
          <div class="fl">
            <van-checkbox v-model="checked" checked-color="#F20023" @click="handleCheckedAll">
              全选
            </van-checkbox>
            <div class="pro_total_details">
              <div class="total">
                <div class="totalprice">
                  <div class="ppo">
                    <div class="totalname">合计:</div>
                    <div class="smallprice">
                      <sub>¥</sub>
                      {{ parseFloat(totalPrice).toFixed(2) }}
                    </div>
                  </div>
                  <div class="ppo">
                    <div class="oldprice">¥{{ parseFloat(oldtotalmoney).toFixed(2) }}</div>
                    <div
                      class="offerdetails"
                      v-if="discountrule.discountenable == 1 || fullgiftrule.actstatus == 1"
                      @click="showofferdetails = true"
                    >
                      <div class="flp">优惠明细</div>
                      <img src="../../assets/images/upred.png" />
                    </div>
                  </div>
                </div>
                <!--<span class="fh">¥</span>-->
                <!--<span class="positive">{{totalPrice | salespricepositive}}</span>-->
                <!--<span class="dian">.</span>-->
                <!--<span class="decimal">{{totalPrice | salespricedecimal}}</span>-->
                <!--<span class="oldprice">¥{{parseFloat(oldtotalmoney).toFixed(2)}}</span>-->
                <!--<div class="offerdetails" @click="showofferdetails = true">-->
                <!--优惠明细-->
                <!--<img src="../../assets/images/upred.png"/>-->
                <!--</div>-->
              </div>
            </div>
          </div>
          <div class="fr">
            <div class="btn" @click="settlement">
              <div class="gobuy">去结算({{ resultlist.length }})</div>
              <!--<img src="../../assets/images/testsettlement.png"/>-->
            </div>
          </div>
        </div>
      </div>
    </div>
    <van-sku
      close-on-click-overlay
      hide-quota-text
      v-model="showsku"
      :sku="sku"
      :goods="goods"
      :goods-id="productId"
      :quota="maxNum"
      :hide-stock="sku.hide_stock"
      :custom-stepper-config="customStepperConfig"
      class="good_sku"
      ref="sku"
      @sku-selected="checkedSku"
      :initial-sku="initialSku"
    >
      <template slot="sku-header" slot-scope="props">
        <div class="van-sku-header van-hairline--bottom">
          <div class="van-sku-header__img-wrap">
            <img v-lazy="goods.picture" />
          </div>
          <div class="van-sku-header__goods-info">
            <div class="van-sku-name">{{ goods.title }}</div>
            <div class="van-sku-header-item">
              {{ skuname === '' ? '请选择商品规格' : '已选 ' + skuname }}
            </div>
            <div class="van-sku__goods-price">
              <span class="van-sku__price-symbol">¥</span>
              <span class="van-sku__price-num">{{ skuprice }}</span>
            </div>
            <!--<i class="van-icon van-icon-clear van-sku__close-icon" @click="showsku = false"></i>-->
          </div>
        </div>
      </template>
      <template slot="sku-stepper">
        <div class="nnn"></div>
      </template>
      <template slot="sku-actions" slot-scope="props">
        <div class="van-sku-actions">
          <van-button square size="large" type="danger" class="sure" @click="onConfirmClicked">
            确定
          </van-button>
        </div>
      </template>
    </van-sku>
    <!--<van-overlay :show="showofferdetails" @click="showofferdetails = false" :z-index="98"/>-->
    <div style="z-index: 2000; position: fixed">
      <van-action-sheet
        v-model="showofferdetails"
        title="优惠明细"
        class="offer"
        close-on-click-overlay
      >
        <div class="offerdetailsdis">
          <div class="ofd1">*实际优惠金额以下单页为准</div>
          <div class="list">
            <div class="item goodstotalprice">
              <div class="tit">商品总额</div>
              <div class="value">¥{{ parseFloat(saletotalmoney).toFixed(2) }}</div>
            </div>
            <div class="item" v-if="discountrule.discountenable == 1">
              <div class="tit">周年庆折上折活动</div>
              <div class="value">-¥{{ parseFloat(discounmoney).toFixed(2) }}</div>
            </div>
            <div class="item combined">
              <div class="tit">合计</div>
              <div class="value">¥{{ parseFloat(totalPrice).toFixed(2) }}</div>
            </div>
            <div class="item desc">
              <div class="tit">(未计算运费、现金券、金币，请在下单页查看)</div>
            </div>
          </div>
        </div>
      </van-action-sheet>
    </div>
    <!--活动服务-->
    <div class="presale_info_dialog" v-if="showPresale == true">
      <div class="dialog">
        <div class="header1">
          <div class="van-divider">预售购买</div>
        </div>
        <div class="content">
          {{ presaledescpt }}
        </div>
        <div class="btn" @click="presell">我知道了</div>
      </div>
    </div>
    <!--活动服务-->
    <van-action-sheet v-model="showaction" title="活动介绍">
      <div class="van-action_model">
        <div class="van-item" v-for="(item, index) in msglist" :key="index">
          <div class="tit">
            <van-tag color="#FEE9E6" text-color="#F12A0E">{{ item.actlabel }}</van-tag>
            {{ item.name }}
          </div>
          <div class="con">
            {{ item.desc }}
          </div>
        </div>
        <div class="btn">
          <van-button round type="danger" class="vanbtn" @click="showaction = false">
            确定
          </van-button>
        </div>
      </div>
    </van-action-sheet>
    <div class="homeBtn" @click="homeClick">
      <img src="/static/images/homebtn.png" />
    </div>
  </div>
</template>

<script>
import { isWeixin, fenxiang, Base64 } from '../../assets/common/js/config'
import { Sku, Tag, Overlay } from 'vant'
import skufunc from '../../assets/common/js/sku_func'
export default {
  name: 'community-promote-act',
  components: {
    [Sku.name]: Sku,
    [Tag.name]: Tag,
    [Overlay.name]: Overlay
  },
  data() {
    return {
      actImgPath: '',
      showPresale: false,
      currentdiscount: 0,
      oldtotalmoney: 0,
      discounmoney: 0,
      currentfullgiftmoney: 0,
      saletotalmoney: 0,
      showofferdetails: false,
      showaction: false,
      msglist: [],
      presaledescpt: '',
      FlodMsg: '',
      discountrule: {},
      fullgiftrule: {},
      halfprice: {},
      resultlist: [],
      showsku: false,
      resultid: this.$route.query.communityid ? this.$route.query.communityid : '',
      // codeStr: '',
      // txtStr: '',
      info: {},
      list: [],
      nowPage: 1,
      pagesize: 10,
      noDataText: '————\n客官，么有啦~\n————',
      listItem: {},
      itemIndex: null,
      skuname: '',
      skuprice: '197.00-218.90',
      productId: null,
      maxNum: null,
      sku: {
        tree: [],
        list: [],
        price: '1.00',
        stock_num: 227,
        collection_id: 2261,
        none_sku: false,
        hide_stock: false
      },
      goods: {
        title: '测试商品',
        picture: ''
      },
      initialSku: {},
      customStepperConfig: {
        quotaText: '每次限购xxx件',
        handleOverLimit: (data) => {
          const { action, limitType, quota, quotaUsed } = data
          if (action === 'minus') {
            this.$toast('至少选择一件商品')
          } else if (action === 'plus') {
          }
        },
        handleStepperChange: (currentValue) => {},
        stockNum: 1999,
        stockFormatter: (stockNum) => {}
      },
      totalnum: 0,
      checked: true
    }
  },
  mounted: function () {
    if (!isWeixin()) {
      this.$router.replace('/')
      return
    }
    this.getData()
  },
  beforeRouteEnter(to, from, next) {
    let boolvalue = true
    if (to.query.pt === 'app' && to.query.oper === 'login') {
      boolvalue = false
    } else if (from.path === '/code') {
      boolvalue = false
    } else if (from.path === '/order') {
      boolvalue = false
    }
    if (boolvalue) {
      // 当前页面刷新不需要切换位置
      localStorage.removeItem('skuids')
      localStorage.removeItem('buynum')
      localStorage.removeItem('itemid')
      next()
    } else {
      next()
    }
  },
  computed: {
    checkAlled: function () {
      if (this.info.itemlist && this.info.itemlist.length > 0) {
        if (this.resultlist && this.resultlist.length > 0) {
          if (this.info.itemlist.length <= this.resultlist.length) {
            return true
          }
        }
        return false
      }
    },
    totalPrice: function () {
      let that = this
      let Price = 0
      that.totalnum = 0
      let goodsnum = 0
      let money = 0
      that.oldtotalmoney = 0
      that.saletotalmoney = 0
      that.discounmoney = 0
      that.currentdiscount = 0
      that.FlodMsg = ''
      if (that.info.itemlist && that.info.itemlist.length > 0) {
        that.info.itemlist.forEach(function (good, i) {
          if (that.resultlist && that.resultlist.length > 0) {
            that.resultlist.forEach(function (item, index) {
              if (item === good.skuid) {
                Price = Price + parseFloat(good.sales_price) * parseInt(good.num)
                that.oldtotalmoney += parseFloat(good.cost_price) * parseInt(good.num)
                that.saletotalmoney += parseFloat(good.sales_price) * parseInt(good.num)
                that.totalnum = that.totalnum + parseInt(good.num)
                if (good.isdiscount == 1) {
                  goodsnum += parseInt(good.num)
                  money += parseFloat(good.sales_price) * parseInt(good.num)
                }
              }
            })
          }
        })
        // 折上折
        if (that.discountrule && that.discountrule.discountenable == 1) {
          let discountlist = that.discountrule.discountlist
          if (parseInt(goodsnum) == 0) {
            var discount = discountlist[0].discount
            var txt = (discount * 100) % 10 == 0 ? (discount * 100) / 10 : discount * 100
            that.FlodMsg = '惊喜！选购活动商品最高可享受' + txt + '折'
            that.currentdiscount = 1
          } else if (parseInt(goodsnum) >= parseInt(discountlist[0].itemnum)) {
            let discount = discountlist[0].discount
            let txt = (discount * 100) % 10 == 0 ? (discount * 100) / 10 : discount * 100
            if (that.fullgiftrule.actstatus && parseInt(that.fullgiftrule.actstatus) == 1) {
              that.FlodMsg = ''
            } else {
              that.FlodMsg = '惊喜！已选' + goodsnum + '件享' + txt + '折'
            }
            that.currentdiscount = discount
          } else if (parseInt(goodsnum) < parseInt(discountlist[discountlist.length - 1].itemnum)) {
            let discount1 = discountlist[discountlist.length - 1].discount
            let txt = (discount1 * 100) % 10 == 0 ? (discount1 * 100) / 10 : discount1 * 100
            that.FlodMsg =
              '惊喜！已选' +
              goodsnum +
              '件，再加' +
              (parseInt(discountlist[discountlist.length - 1].itemnum) - goodsnum) +
              '件即可享受' +
              txt +
              '折。'
            that.currentdiscount = 1
          } else {
            try {
              discountlist.forEach(function (item, index) {
                if (parseInt(goodsnum) >= parseInt(item.itemnum)) {
                  let discount1 = item.discount
                  let discount2 = discountlist[index - 1].discount
                  let txt = (discount1 * 100) % 10 == 0 ? (discount1 * 100) / 10 : discount1 * 100
                  let txt1 = (discount2 * 100) % 10 == 0 ? (discount2 * 100) / 10 : discount2 * 100
                  that.FlodMsg =
                    '惊喜！已选' +
                    goodsnum +
                    '件享' +
                    txt +
                    '折，再加' +
                    (parseInt(discountlist[index - 1].itemnum) - goodsnum) +
                    '件即可享受' +
                    txt1 +
                    '折。'
                  that.currentdiscount = discount1
                  throw new Error()
                }
              })
            } catch (e) {}
          }
        }
        if (that.currentdiscount > 0) {
          Price = Price * that.currentdiscount
          that.discounmoney = that.saletotalmoney - Price
        }
      }
      return Price
    },
    fullGiftMsg: function () {
      var that = this
      let fullGiftMsg = ''
      if (that.fullgiftrule && parseInt(that.fullgiftrule.actstatus) == 1 && !that.FlodMsg) {
        if (this.fullgiftrule.rulelist && this.fullgiftrule.rulelist.length > 0) {
          var rulelist = this.fullgiftrule.rulelist
          var price = 0
          that.isChooseProduct.forEach(function (item) {
            if (item.isfullgift == 1) {
              if (parseInt(item.isdiscount) == 1 && that.currentdiscount > 0) {
                price +=
                  Number(item.sales_price) * parseInt(item.num) * Number(that.currentdiscount)
              } else {
                price += Number(item.sales_price) * parseInt(item.num)
              }
            }
          })
          that.currentfullgiftmoney = parseFloat(price).toFixed(2)
          if (!isNaN(Number(that.currentfullgiftmoney))) {
            if (
              parseFloat(that.currentfullgiftmoney) == 0 ||
              parseFloat(that.currentfullgiftmoney) <
                parseFloat(rulelist[rulelist.length - 1].allmoney)
            ) {
              let m = !isNaN(Number(rulelist[rulelist.length - 1].allmoney))
                ? parseFloat(
                    Number(rulelist[rulelist.length - 1].allmoney) -
                      Number(that.currentfullgiftmoney)
                  ).toFixed(2)
                : '0.00'
              let m1 = !isNaN(parseFloat(rulelist[rulelist.length - 1].senditemprice))
                ? parseFloat(rulelist[rulelist.length - 1].senditemprice).toFixed(2)
                : '0.00'
              fullGiftMsg =
                '惊喜！还差<span>' +
                m +
                '</span>元，即送价值<span>' +
                m1 +
                '</span>元' +
                rulelist[rulelist.length - 1].senditemname
            } else if (parseFloat(that.currentfullgiftmoney) >= parseFloat(rulelist[0].allmoney)) {
              let m = !isNaN(parseFloat(rulelist[0].allmoney))
                ? parseFloat(rulelist[0].allmoney).toFixed(2)
                : '0.00'
              let m1 = !isNaN(parseFloat(rulelist[0].senditemprice))
                ? parseFloat(rulelist[0].senditemprice).toFixed(2)
                : '0.00'
              fullGiftMsg =
                '惊喜！已满<span>' +
                m +
                '</span>元，可领价值<span>' +
                m1 +
                '</span>元' +
                rulelist[0].senditemname
            } else {
              try {
                rulelist.forEach(function (item, index) {
                  if (parseFloat(that.currentfullgiftmoney) >= parseFloat(item.allmoney)) {
                    let m = !isNaN(parseFloat(rulelist[index - 1].allmoney))
                      ? parseFloat(
                          Number(rulelist[index - 1].allmoney) - Number(that.currentfullgiftmoney)
                        ).toFixed(2)
                      : '0.00'
                    let m1 = !isNaN(parseFloat(rulelist[index - 1].senditemprice))
                      ? parseFloat(rulelist[index - 1].senditemprice).toFixed(2)
                      : '0.00'
                    fullGiftMsg =
                      '惊喜！还差<span>' +
                      m +
                      '</span>元，即送价值<span>' +
                      m1 +
                      '</span>元' +
                      rulelist[index - 1].senditemname
                    throw new Error()
                  }
                })
              } catch (e) {}
            }
            return fullGiftMsg
          }
        }
      }
    },
    isChooseProduct: function () {
      let that = this
      let list = []
      if (that.info.itemlist && that.info.itemlist.length > 0) {
        that.info.itemlist.forEach(function (good, i) {
          if (that.resultlist && that.resultlist.length > 0) {
            that.resultlist.forEach(function (item, index) {
              if (item === good.skuid) {
                list.push(good)
              }
            })
          }
        })
      }
      return list
    }
  },
  methods: {
    getData() {
      var base = new Base64()
      let url = this.$ajax.getCkCommunityActList_URL + '?communityid=' + this.resultid
      if (isWeixin()) {
        fenxiang({
          title: encodeURIComponent('可丽金专场直播开启，限时抢购送壕礼'),
          desc: encodeURIComponent('快来和主播现场一起体验，科学之选，安心护肤的可丽金吧'),
          type: 'community',
          dataStr:
            'type=community&params=' + base.encode(JSON.stringify({ communityid: this.resultid })),
          path: 'compro'
        })
      }
      this.$customRequestAjax(url).then((res) => {
        if (res.data.code === 200) {
          this.actImgPath = res.data.act_banner
          let skuids = []
          if (localStorage.getItem('skuids')) {
            skuids = JSON.parse(localStorage.getItem('skuids'))
            this.resultlist = skuids
          }
          let buynum = []
          if (localStorage.getItem('buynum')) {
            buynum = JSON.parse(localStorage.getItem('buynum'))
          }
          let itemids = []
          if (localStorage.getItem('buynum')) {
            itemids = JSON.parse(localStorage.getItem('itemid'))
          }
          this.info = res.data
          // let codelist = this.info.skin_type_list.map((item) => {
          //   return item.code
          // })
          // this.codeStr = codelist.join(' ')
          // let txtlist = this.info.skin_type_list.map((item) => {
          //   return item.text
          // })
          // this.txtStr = txtlist.join(' ')
          let items = []
          let resultitems = []
          res.data.itemlist.forEach(function (item, index) {
            skuids.forEach(function (skuid, i) {
              if (item.itembaseid === itemids[i]) {
                item.sku_rule_list.forEach(function (good, j) {
                  if (good.skuid === skuid) {
                    item.skuid = good.skuid
                    item.spec = good.sku_name
                    item.sales_price = good.sales_price
                    item.cost_price = good.cost_price
                    item.path = good.spec_imgpath
                    item.islimit = good.islimit
                    item.issale = good.issale
                    item.canbuycnt = good.canbuycnt
                    item.lib_warning = good.lib_warning
                    item.num = buynum[i]
                  }
                })
              } else {
                if (item.skuid === skuid) {
                  item.num = buynum[i]
                }
              }
            })
            if (!item.num) {
              item.num = 1
            }
            items.push(item)
            resultitems.push(item.skuid)
          })
          this.info.itemlist = items
          this.list = this.info.itemlist
          this.discountrule = res.data.discountrule
          this.halfprice = {
            halfpricestatus: res.data.halfpricestatus,
            halfpricedesc: res.data.halfpricedesc,
            halfactname: res.data.halfactname,
            halfactlabel: res.data.halfactlabel
          }
          this.presaledescpt = res.data.presaledescpt
          this.fullgiftrule = res.data.fullgiftrule
          if (!this.resultlist || this.resultlist.length <= 0) {
            this.resultlist = resultitems
          }
        } else {
          setTimeout(() => {
            this.$router.replace('/')
          }, 100)
        }
      })
    },
    productDetailsFn(items) {
      console.log(items)
      this.$router.push({
        path: '/productdetail',
        query: {
          itemid: items.itembaseid,
          communityid: this.resultid
        }
      })
    },
    homeClick: function () {
      this.$router.push('/')
    },
    // handleTest () {
    //   if (this.$route.query.pt && (this.$route.query.pt).toLowerCase() === 'app') {
    //     this.$router.push({
    //       path: '/ndo',
    //       query: {
    //         pt: this.$route.query.pt,
    //         token: this.$route.query.token,
    //         islogin: this.$route.query.islogin
    //       }
    //     })
    //   } else {
    //     this.$router.push('/ndo')
    //   }
    // },
    handleCheckedAll() {
      if (this.checked === false) {
        let items = []
        this.info.itemlist.forEach(function (item, index) {
          items.push(item.skuid)
        })
        this.resultlist = items
      } else {
        this.resultlist = []
      }
    },
    openSku(item, idx) {
      skufunc.openSku_compro(item, idx, this)
    },
    checkedSku(skuValue) {
      skufunc.checkedSku_compro(skuValue, this)
    },
    presell() {
      this.showPresale = false
      this.settlement()
    },
    onConfirmClicked() {
      skufunc.onConfirmClicked_compro(this)
    },
    settlement() {
      var that = this
      let skuids = that.isChooseProduct.map((item) => {
        return item.skuid
      })
      let buynum = that.isChooseProduct.map((item) => {
        return item.num
      })
      let itemid = that.isChooseProduct.map((item) => {
        return item.itembaseid
      })
      let ispresale = 0
      that.isChooseProduct.forEach(function (item) {
        if (item.ispresale == 1) {
          ispresale = 1
        }
      })
      if (that.isChooseProduct && that.isChooseProduct.length > 0) {
        // if (this.$route.query.pt && (this.$route.query.pt).toLowerCase() === 'app') { // 移动APP情况
        //   let obj = {
        //     type: 'settlement',
        //     skuids: skuids,
        //     buynum: buynum,
        //     skin_type: that.info.skin_type && that.info.skin_type.length > 0 ? that.info.skin_type : that.codeStr + ' (' + that.txtStr + ')',
        //     resultid: that.resultid
        //   }
        //   if (this.$route.query.islogin && parseInt(this.$route.query.islogin) === 0) {
        //     localStorage.setItem('skuids', JSON.stringify(skuids))
        //     localStorage.setItem('buynum', JSON.stringify(buynum))
        //     localStorage.setItem('itemid', JSON.stringify(itemid))
        //   }
        //   if (this.$route.query.islogin && parseInt(this.$route.query.islogin) === 1) {
        //     if (this.showPresale == false && ispresale == 1 && !localStorage.getItem('appndopresale')) {
        //       that.showPresale = true
        //       localStorage.setItem('appndopresale', '1')
        //       return
        //     }
        //   }
        //
        //   window.ReactNativeWebView.postMessage(JSON.stringify(obj))
        // } else
        if (!isWeixin()) {
          // 非微信浏览器情况
          if (this.waptoken.waptoken && this.waptoken.waptoken === this.waptoken.tourists) {
            // 未登录情况逻辑处理
            that.$store.commit('PATH_VALUE', JSON.stringify({ communityid: that.resultid }))
            this.$router.push({
              path: '/login',
              query: {
                routeval: 'compro'
              }
            })
            localStorage.setItem('skuids', JSON.stringify(skuids))
            localStorage.setItem('buynum', JSON.stringify(buynum))
            localStorage.setItem('itemid', JSON.stringify(itemid))
          } else {
            // 登录情况逻辑处理
            localStorage.setItem('skuids', JSON.stringify(skuids))
            localStorage.setItem('buynum', JSON.stringify(buynum))
            localStorage.setItem('itemid', JSON.stringify(itemid))
            that.handleJoinData()
          }
        } else {
          // 微信浏览器情况
          localStorage.setItem('skuids', JSON.stringify(skuids))
          localStorage.setItem('buynum', JSON.stringify(buynum))
          localStorage.setItem('itemid', JSON.stringify(itemid))
          that.handleJoinData()
        }
      } else {
        that.$toast('请选择需要购买的商品')
      }
    },
    handleJoinData() {
      var that = this
      var shopConfirmResult = {
        skuidArr: [],
        itemNum: [],
        skuidArrOversea: [],
        from: 2, // 购物车：0；立即购买：1；皮肤测试：3
        orderfrom: 1,
        itemNumOversea: [],
        totalmoney: that.totalPrice,
        totalnum: that.totalnum,
        communityid: that.resultid
      }
      let ispresale = 0
      that.isChooseProduct.forEach(function (item) {
        if (item.isoversea === 1) {
          shopConfirmResult.skuidArrOversea.push(item.skuid)
          shopConfirmResult.itemNumOversea.push(item.num)
        } else {
          shopConfirmResult.skuidArr.push(item.skuid)
          shopConfirmResult.itemNum.push(item.num)
        }
        if (item.ispresale == 1) {
          ispresale = 1
        }
      })
      var urlCheck
      if (shopConfirmResult.skuidArr.length > 0 && shopConfirmResult.skuidArrOversea.length <= 0) {
        if (this.showPresale == false && ispresale == 1 && !localStorage.getItem('compresale')) {
          that.showPresale = true
          localStorage.setItem('compresale', '1')
        } else {
          urlCheck =
            that.$ajax.checkOrder_URL +
            '?skuids=' +
            shopConfirmResult.skuidArr.join() +
            '&buynum=' +
            shopConfirmResult.itemNum.join() +
            '&communityid=' +
            that.resultid
          that.$customRequestAjax(urlCheck).then((res) => {
            if (res.data.code == 200) {
              localStorage.setItem('shopConfirmResult', JSON.stringify(shopConfirmResult))
              sessionStorage.removeItem('choose_integral')
              sessionStorage.removeItem('choose_coupon')
              sessionStorage.removeItem('choose_product')
              sessionStorage.removeItem('oversea_List')
              that.$router.push('/order')
            }
          })
        }
      } else if (
        shopConfirmResult.skuidArrOversea.length > 0 &&
        shopConfirmResult.skuidArr.length <= 0
      ) {
        if (this.showPresale == false && ispresale == 1 && !localStorage.getItem('compresale')) {
          that.showPresale = true
          localStorage.setItem('compresale', '1')
        } else {
          // 为了使普通商品和海外商品的确认订单接口参数key值保持一致
          shopConfirmResult.skuidArr = shopConfirmResult.skuidArrOversea
          shopConfirmResult.itemNum = shopConfirmResult.itemNumOversea
          shopConfirmResult.skuidArrOversea = []
          shopConfirmResult.itemNumOversea = []
          urlCheck =
            that.$ajax.checkOrder_URL +
            '?skuids=' +
            shopConfirmResult.skuidArr.join() +
            '&buynum=' +
            shopConfirmResult.itemNum.join() +
            '&communityid=' +
            that.resultid
          that.$customRequestAjax(urlCheck).then((res) => {
            if (res.data.code == 200) {
              localStorage.setItem('shopConfirmResult', JSON.stringify(shopConfirmResult))
              sessionStorage.removeItem('choose_integral')
              sessionStorage.removeItem('choose_coupon')
              sessionStorage.removeItem('choose_product')
              sessionStorage.removeItem('oversea_List')
              that.$router.push('/order')
            }
          })
        }
      } else {
        that.$toast('海外商品不能与普通商品一起购买')
      }
    },
    // handleGoList () {
    //   if (this.$route.query.pt && (this.$route.query.pt).toLowerCase() === 'app') { // 移动APP情况
    //     window.ReactNativeWebView.postMessage(JSON.stringify({
    //       type: 'proList'
    //     }))
    //   }
    //   this.$router.push('/classification')
    // },
    showActDesc: function (obj) {
      var that = this
      that.msglist = []
      if (
        that.discountrule &&
        that.discountrule.discountenable == 1 &&
        that.discountrule.discountlist &&
        obj.isdiscount == 1
      ) {
        var msg = []
        that.discountrule.discountlist.forEach(function (item, index) {
          var txt =
            (item.discount * 100) % 10 == 0 ? (item.discount * 100) / 10 : item.discount * 100
          msg.push(item.itemnum + '件' + txt + '折')
        })
        var discountruledesc = '满' + msg.join(',')
        that.msglist.push({
          enable: that.discountrule.discountenable,
          shortdesc: discountruledesc,
          desc: that.discountrule.discountdescription,
          name: that.discountrule.name,
          actlabel: that.discountrule.actlabel
        })
      }
      if (
        that.fullgiftrule &&
        that.fullgiftrule.actstatus == 1 &&
        that.fullgiftrule.rulelist &&
        obj.isfullgift == 1
      ) {
        that.msglist.push({
          enable: that.fullgiftrule.actstatus,
          shortdesc: that.fullgiftrule.actdesc,
          desc: that.fullgiftrule.actdesc,
          name: that.fullgiftrule.actname,
          actlabel: that.fullgiftrule.actlabel
        })
      }
      if (that.halfprice.halfpricestatus == 1) {
        that.msglist.push({
          enable: that.halfprice.halfpricestatus,
          shortdesc: that.halfprice.halfpricedesc,
          desc: that.halfprice.halfpricedesc,
          name: that.halfprice.halfactname,
          actlabel: that.halfprice.halfactlabel
        })
      }
      that.showaction = true
    }
  },
  filters: {
    salespricepositive(value) {
      return parseInt(value)
    },
    salespricedecimal(value) {
      let v = parseFloat(value).toFixed(2) + ''
      v = v.substring(v.indexOf('.') + 1)
      return v
    }
  },
  watch: {
    checkAlled(val) {
      this.checked = val
    }
  }
}
</script>

<style scoped lang="scss">
.container {
  background: #efeef1;
  .result_tit {
    position: absolute;
    top: 0.15rem;
    left: 0;
    width: 100%;
    img {
      width: 2.48rem;
      height: 0.52rem;
      margin: 0 auto;
    }
  }
  .result_instructions {
    background: url('../../assets/images/testresultbg.png') top center no-repeat;
    background-size: 100% 100%;
    margin: 0.18rem 0.1rem;
    padding: 0 0.16rem;
    padding-bottom: 0.49rem;
    .result_list_x {
      position: relative;
      min-height: 1.12rem;
      margin-top: 0.18rem;
      .header {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        z-index: 0;
        img {
          width: 2.87rem;
          height: 0.4rem;
          margin: 0 auto;
        }
      }
      .con_d {
        position: absolute;
        top: 0.2rem;
        left: 0;
        width: 100%;
        font-size: 0.15rem;
        line-height: 0.21rem;
        color: #6c6967;
        background: #fef6e2;
        border-radius: 0.1rem;
        border: solid 1px #323232;
        padding: 0.24rem 0.16rem;
      }
    }
    .goprolist {
      margin-top: 1.55rem;
      font-size: 0.15rem;
      line-height: 0.21rem;
      color: #434343;
      font-weight: 400;
      display: flex;
      display: -webkit-flex;
      display: -moz-flex;
      display: -ms-flex;
      display: -o-flex;
      align-items: center;
      -webkit-align-items: center;
      -moz-align-items: center;
      -ms-align-items: center;
      -o-align-items: center;
      justify-content: center;
      -webkit-justify-content: center;
      -moz-justify-content: center;
      -ms-justify-content: center;
      -o-justify-content: center;
      span {
        color: #000;
        width: 0.15rem;
        height: 0.15rem;
        display: block;
        background: url('../../assets/images/ndoright.png') no-repeat center;
        background-size: 80% 80%;
        margin-left: 0.02rem;
      }
    }
    .result_title {
      display: flex;
      justify-content: center;
      align-content: flex-start;
      font-size: 0.19rem;
      font-weight: 600;
      color: #434343;
      padding-top: 0.76rem;
      text-align: justify;
      div:nth-child(1),
      div:nth-child(3) {
        color: #7f776e;
        font-size: 0.27rem;
        line-height: 0.38rem;
      }
      div:nth-child(2) {
        margin-top: 0.1rem;
      }
    }
    .result_n1 {
      font-size: 0.13rem;
      margin-top: 0.08rem;
      text-align: center;
      color: #8e8e8d;
    }
    .result_n2_desc {
      margin-top: 0.18rem;
      font-size: 0.13rem;
      table td:nth-child(odd) {
        background: #fff2ea;
        text-align: center;
        vertical-align: middle;
      }
      table td:nth-child(even) {
        background: #e8eefc;
        text-align: center;
        vertical-align: middle;
      }
      .main_t {
        font-size: 0.16rem;
        line-height: 0.22rem;
      }
      .main_d {
        font-size: 0.11rem;
        color: #8e8e8d;
        line-height: 0.16rem;
      }
      .main_v {
        padding: 0.09rem 0;
      }
    }
    .result_test {
      margin-top: 0.19rem;
      img {
        width: 1.12rem;
        height: 0.44rem;
        margin: 0 auto;
      }
    }
    .result_skin_peculiarity {
      margin-top: 0.46rem;
      .header {
        .tit {
          img {
            width: 0.95rem;
            height: 0.36rem;
          }
          margin-bottom: 0.1rem;
        }
        border-bottom: solid 1px #939393;
      }
      .con {
        padding-top: 0.04rem;
        font-size: 0.13rem;
        line-height: 0.18rem;
        color: #8d8d8d;
      }
    }
    .result_testnursing {
      margin-top: 0.19rem;
      .header {
        .tit {
          img {
            width: 0.95rem;
            height: 0.36rem;
          }
          margin-bottom: 0.1rem;
        }
        border-bottom: solid 1px #939393;
      }
      .con {
        padding-top: 0.04rem;
        font-size: 0.13rem;
        line-height: 0.18rem;
        color: #8d8d8d;
      }
    }
  }
  .result_list {
    position: relative;
    .header {
      overflow: hidden;
      margin-bottom: 0.1rem;
      /*position: absolute;*/
      /*top: 0;*/
      /*left: 0;*/
      width: 100%;
      z-index: 0;
      /*background: #FFE4CC;*/
      img {
        width: 100%;
        /*height: .74rem;*/
        /*margin: 0 auto;*/
      }
    }
    .list {
      /*position: absolute;*/
      /*top: .7rem;*/
      /*left: 0;*/
      width: 100%;
      z-index: 1;
      padding: 0 0.11rem;
      /*background: #FFE4CC;*/
      padding-bottom: 0.8rem;
      .itembg {
        /*background: url('../../assets/images/testskinplanitembg.png') center no-repeat;*/
        /*background-size: 100% 100%;*/
        background: #fffeff;
        border-radius: 0.04rem;
        padding: 0.17rem 0.11rem;
        margin-bottom: 0.11rem;
        .item {
          display: flex;
          display: -o-flex;
          display: -moz-flex;
          display: -ms-flex;
          display: -webkit-flex;
          align-items: center;
          -o-align-items: center;
          -moz-align-items: center;
          -ms-align-items: center;
          -webkit-align-items: center;
          .proitem {
            display: flex;
            display: -o-flex;
            display: -moz-flex;
            display: -ms-flex;
            display: -webkit-flex;
            align-items: flex-start;
            -o-align-items: flex-start;
            -moz-align-items: flex-start;
            -ms-align-items: flex-start;
            -webkit-align-items: flex-start;
            flex: 1;
            -webkit-flex: 1;
            -o-flex: 1;
            -moz-flex: 1;
            -ms-flex: 1;
            .img {
              margin-left: 0.08rem;
              img {
                width: 0.85rem;
                height: 0.85rem;
              }
            }
            .con {
              width: 100%;
              margin-left: 0.07rem;
              height: 0.85rem;
              position: relative;
              .tit {
                font-size: 0.13rem;
                color: #292929;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
                overflow: hidden;
                margin-top: 0.04rem;
              }
              .spec {
                font-size: 0.11rem;
                color: #6c6c6c;
                margin-top: 0.03rem;
                height: 0.19rem;
                .spec_con {
                  float: left;
                  background: #f6f6f6;
                  border-radius: 0.1rem;
                  padding: 0.01rem 0.07rem;
                  line-height: 0.16rem;
                  padding-bottom: 0.02rem;
                  display: flex;
                  align-content: center;
                  align-items: center;
                  .van-icon {
                    font-size: 0.09rem;
                    margin-left: 0.03rem;
                  }
                }
              }
              .priceAndnum {
                position: absolute;
                bottom: 0;
                left: 0;
                width: 100%;
                display: flex;
                justify-content: space-between;
                align-items: center;
                .price {
                  display: flex;
                  align-items: center;
                  line-height: 0.44rem;
                  color: #e22a41;
                  font-size: 0;
                  .fh {
                    font-size: 0.13rem;
                    line-height: 0.22rem;
                  }
                  .positive {
                    font-size: 0.16rem;
                    font-weight: 600;
                    line-height: 0.22rem;
                  }
                  .dian {
                    font-size: 0.15rem;
                    line-height: 0.22rem;
                  }
                  .decimal {
                    font-size: 0.13rem;
                    line-height: 0.22rem;
                  }
                }
              }
            }
          }
        }
        .act_desc_tag {
          font-size: 0.12rem;
          margin-top: 0.08rem;
          margin-left: 0.28rem;
          .van-icon-arrow {
            float: right;
          }
        }
        .act_desc_time {
          font-size: 0.11rem;
          margin-left: 0.28rem;
          color: #f12a0e;
          margin-top: 0.04rem;
          display: flex;
          align-items: center;
          img {
            width: 0.12rem;
          }
          .txt {
            font-size: 0.12rem;
            color: #f12a0e;
            transform: scale(0.92, 0.92);
            margin-left: -0.03rem;
            line-height: 0.17rem;
          }
        }
        .act_desc_time .van-icon-warning-o {
          float: left;
          font-size: 0.16rem;
          display: block;
          margin-right: 0.04rem;
        }
        .act_desc {
          font-size: 0.12rem;
          transform: scale(0.8);
          margin-top: 0.04rem;
          color: #fc0324;
        }
      }
    }
    .settlement {
      position: fixed;
      bottom: 0;
      left: 0;
      width: 100%;
      z-index: 2002;
      background: #fff;
      .pro_tools:before {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 1px;
        transform: translateY(-50%);
        background: #bebebe;
        content: '';
      }
      .pro_tools {
        position: relative;
        height: 0.52rem;
        font-size: 0.12rem;
        display: flex;
        align-content: center;
        justify-content: space-between;
        padding-left: 0.16rem;
        padding-right: 0.12rem;
      }
      .fl {
        display: flex;
        align-content: center;
      }
      /*<!--.offerdetails {-->*/
      /*<!--font-size: .11rem;-->*/
      /*<!--color: #FC0324;-->*/
      /*<!--margin-left: -.07rem;-->*/
      /*<!--transform: scale(0.9, 0.9);-->*/
      /*<!--display: flex;-->*/
      /*<!--align-items: center;-->*/
      /*<!--img {-->*/
      /*<!--!*display: inline-block;*!-->*/
      /*<!--width: .11rem;-->*/
      /*<!--vertical-align: middle;-->*/
      /*<!--margin-left: .02rem;-->*/
      /*<!--}-->*/
      /*<!--}-->*/
      /*.total {*/
      /*float: left;*/
      /*padding-top: .01rem;*/
      /*margin-left: .19rem;*/
      /*color: #222222;*/
      /*.oldprice{*/
      /*font-size: .12rem;*/
      /*color:#6C6C6C;*/
      /*text-decoration: line-through;*/
      /*}*/
      /*.fh {*/
      /*font-size: .13rem;*/
      /*line-height: .22rem;*/
      /*}*/
      /*.positive {*/
      /*font-size: .16rem;*/
      /*font-weight: 600;*/
      /*line-height: .22rem;*/
      /*}*/
      /*.dian {*/
      /*font-size: .15rem;*/
      /*line-height: .22rem;*/
      /*}*/
      /*.decimal {*/
      /*font-size: .13rem;*/
      /*line-height: .22rem;*/
      /*}*/
      /*}*/
      .pro_total_details {
        float: left;
        font-size: 0.12rem;
        /*margin-top: .07rem;*/
        margin-left: 0.15rem;
        display: flex;
        display: -webkit-flex;
        display: -moz-flex;
        display: -ms-flex;
        display: -o-flex;
        align-items: center;
        -webkit-align-items: center;
        -moz-align-items: center;
        -ms-align-items: center;
        -o-align-items: center;
        /*height: 0.2rem;*/
        .offerdetails {
          margin-left: 0.01rem;
          display: flex;
          align-items: center;
          justify-content: flex-start;
          .flp {
            font-size: 0.11rem;
            color: #fc0324;
            margin-left: 0.01rem;
            transform: scale(0.9, 0.9);
            float: left;
          }
          img {
            float: left;
            width: 0.11rem;
            vertical-align: middle;
          }
        }
        .total {
          .totalname {
            font-size: 0.13rem;
            /*line-height: .235rem;*/
            color: #252525;
            float: left;
          }
          .totalprice {
            float: left;
            padding-left: 0.05rem;
          }
          .ppo {
            display: flex;
            align-items: center;
            justify-content: flex-start;
          }
          .oldprice {
            font-size: 0.11rem;
            color: #888888;
            text-decoration: line-through;
          }
          .smallprice {
            color: #fc0324;
            font-size: 0.15rem;
            /*line-height: .215rem;*/
            font-weight: bold;
          }
          sub {
            font-weight: normal;
            font-size: 0.11rem;
            vertical-align: baseline;
          }
        }
      }
      .btn {
        display: flex;
        align-items: center;
        height: 0.52rem;
        .gobuy {
          padding: 0 0.05rem;
          font-size: 0.13rem;
          color: #ffffff;
          line-height: 0.325rem;
          text-align: center;
          min-width: 0.85rem;
          height: 0.325rem;
          background: linear-gradient(90deg, rgba(252, 0, 17, 1), rgba(255, 20, 79, 1));
          background: -webkit-linear-gradient(90deg, rgba(252, 0, 17, 1), rgba(255, 20, 79, 1));
          background: -moz-linear-gradient(90deg, rgba(252, 0, 17, 1), rgba(255, 20, 79, 1));
          background: -ms-linear-gradient(90deg, rgba(252, 0, 17, 1), rgba(255, 20, 79, 1));
          background: -o-linear-gradient(90deg, rgba(252, 0, 17, 1), rgba(255, 20, 79, 1));
          border-radius: 0.165rem;
        }
      }
    }
  }
  .offer.van-popup--bottom {
    bottom: 0.44rem;
  }
  .offerdetailsdis {
    .ofd1 {
      font-size: 0.12rem;
      color: #3d3d3d;
      text-align: center;
      line-height: 0.17rem;
      margin-top: 0.18rem;
      margin-bottom: 0.2rem;
    }
    .list {
      padding: 0.15rem;
      .item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 0.14rem;
        padding-bottom: 0.12rem;
        color: #242424;
        line-height: 0.2rem;
        font-weight: 400;
      }
      .goodstotalprice {
        color: #242424;
        font-weight: 600;
      }
      .combined {
        font-size: 0.16rem;
        color: #fc0324;
        line-height: 0.22rem;
        font-weight: 400;
      }
      .desc {
        color: #3d3d3d;
        font-size: 0.12rem;
        line-height: 0.17rem;
        padding-bottom: 0.3rem;
      }
    }
  }
  .van-action-sheet__close {
    background: url('../../assets/images/closex.png') center no-repeat;
    background-size: 0.2rem 0.2rem;
  }
  .van-action_model {
    height: 70vh;
    .van-item {
      padding: 0.14rem;
      .tit {
        font-size: 0.14rem;
        color: #262626;
        font-weight: 400;
        line-height: 0.23rem;
      }
      .con {
        padding-top: 0.1rem;
        line-height: 0.23rem;
        font-size: 0.13rem;
        color: #333333;
      }
    }
    .btn {
      padding: 0.14rem;
      width: 100%;
      position: fixed;
      bottom: 0;
      left: 0;
      .vanbtn {
        width: 100%;
        height: 0.43rem;
        background: linear-gradient(90deg, rgba(252, 3, 36, 1) 0%, rgba(246, 58, 102, 1) 100%);
        border-radius: 0.25rem;
      }
    }
  }
  .presale_info_dialog {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 3001;
    display: -webkit-box;
    display: -moz-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-align-items: center;
    -moz-align-items: center;
    -ms-align-items: center;
    -o-align-items: center;
    align-items: center;
    background: rgba(0, 0, 0, 0.5);
    .dialog {
      width: 79%;
      margin: 0 auto;
      background: #fff;
      border-radius: 0.04rem;
      height: 2.24rem;
      position: relative;
      .header1 {
        width: 70%;
        margin: 0 auto;
        font-weight: bold;
        .van-divider {
          display: -webkit-box;
          display: -webkit-flex;
          display: flex;
          -webkit-box-align: center;
          -webkit-align-items: center;
          align-items: center;
          margin: 0.2rem 0;
          line-height: 0.24rem;
          border-color: #666666;
          border-style: solid;
          border-width: 0;
          color: #333333;
          font-size: 0.21rem;
        }
        .van-divider::before,
        .van-divider::after {
          content: ' ';
          display: block;
          -webkit-box-flex: 1;
          -webkit-flex: 1;
          flex: 1;
          box-sizing: border-box;
          height: 1px;
          border-color: inherit;
          border-style: inherit;
          border-width: 0 0 0;
          margin-right: 0.16rem;
          margin-left: 0.16rem;
        }
      }
      .content {
        width: 80%;
        margin: 0 auto;
        text-align: center;
        color: #444444;
        font-size: 0.14rem;
        margin-top: 0.02rem;
        line-height: 0.2rem;
        height: 1.2rem;
        overflow-y: auto;
      }
      .btn {
        background: #fc0324;
        width: 50%;
        text-align: center;
        color: #fff;
        font-size: 0.15rem;
        border-radius: 0.16rem;
        height: 0.31rem;
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        left: 25%;
        bottom: 0.22rem;
      }
    }
  }
  .additemMsg {
    position: fixed;
    left: 0;
    bottom: 0.52rem;
    width: 100%;
    padding: 0.15rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #fff;
    z-index: 10;
    .msg {
      font-size: 0.12rem;
      line-height: 0.14rem;
      color: #333333;
      display: flex;
      align-items: center;
      img {
        width: 0.13rem;
        margin-right: 0.06rem;
      }
    }
    .btn {
      font-size: 0.12rem;
      color: #ff253e;
      white-space: nowrap;
      margin-left: 0.08rem;
    }
  }
  .homeBtn {
    z-index: 10;
    position: fixed;
    right: 0.17rem;
    bottom: 1.5rem;
    width: 0.4rem;
    height: 0.4rem;
    border-radius: 50%;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0 0.01rem 0.05rem 0 rgba(159, 159, 159, 0.5);
    -webkit-box-shadow: 0 0.01rem 0.05rem 0 rgba(159, 159, 159, 0.5);
    -moz-box-shadow: 0 0.01rem 0.05rem 0 rgba(159, 159, 159, 0.5);
    -ms-box-shadow: 0 0.01rem 0.05rem 0 rgba(159, 159, 159, 0.5);
    -o-box-shadow: 0 0.01rem 0.05rem 0 rgba(159, 159, 159, 0.5);
    display: flex;
    display: -moz-flex;
    display: -ms-flex;
    display: -webkit-flex;
    display: -o-flex;
    flex-direction: column;
    -moz-flex-direction: column;
    -ms-flex-direction: column;
    -webkit-flex-direction: column;
    -o-flex-direction: column;
    justify-content: center;
    -moz-justify-content: center;
    -ms-justify-content: center;
    -webkit-justify-content: center;
    -o-justify-content: center;
    align-items: center;
    -moz-align-items: center;
    -ms-align-items: center;
    -webkit-align-items: center;
    -o-align-items: center;
    img {
      width: 0.4rem;
      height: 0.4rem;
      display: block;
    }
  }
}
</style>

<style lang="scss">
.container {
  .good_sku .van-sku-row__item {
    border-radius: 0.15rem;
    font-size: 0.13rem;
    color: #5e5e5e;
    padding: 0 0.1rem;
    border: solid 1px transparent;
  }
  .good_sku .van-sku-row__item::before {
    background: #eeeff4;
  }
  .good_sku .van-sku__goods-price {
    margin-top: 0.2rem;
  }
  .good_sku .van-sku__price-symbol,
  .van-sku__price-num {
    font-size: 0.16rem;
    color: #fc0324;
    font-weight: 600;
  }
  .good_sku .van-sku-row__item--active {
    border: solid 1px #fc0324;
    background-color: #fcedeb;
    color: #fc0324;
  }
  .good_sku .van-sku-row__item-name {
    padding: 0.06rem;
  }
  .good_sku .van-sku-row__item-img {
    width: 0.2rem;
    height: 0.2rem;
  }
  .good_sku.van-popup--bottom.van-popup--round {
    border-radius: 0;
  }
  .good_sku .van-sku-row__title,
  .van-sku__stepper-title {
    padding-bottom: 0.13rem;
    font-size: 0.13rem;
    color: #333333;
    line-height: 0.18rem;
    font-weight: 600;
  }
  .good_sku .van-sku__stepper {
    border-radius: 0.13rem;
    overflow: hidden;
  }
  .good_sku .van-stepper__minus,
  .van-stepper__plus,
  .van-stepper__input {
    height: 0.22rem;
  }
  .good_sku .van-stepper__minus::before,
  .van-stepper__plus::before {
    width: 9px;
  }
  .good_sku .van-stepper__minus::after,
  .van-stepper__plus::after {
    height: 9px;
  }
  .good_sku .van-sku-row__item--disabled {
    background: #fcfcfc;
    border-radius: 0.15rem;
    border: 1px solid #eeeff4;
    color: #dedede;
    &:before {
      background: #fcfcfc;
    }
  }
  .pro_details_con {
    font-size: 0.14rem;
  }
  .pro_details_con img {
    width: 100% !important;
    height: auto !important;
  }
  .pro_details_con .ckeditor-html5-video {
    width: 100%;
  }
  .pro_details_con .ckeditor-html5-video video {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/actpage/communityPromoteAct.vue